import 'svelte/internal/disclose-version';

Switcher[$.FILENAME] = 'src/web/switcher.svelte';

import * as $ from 'svelte/internal/client';

var root = $.add_locations(
	$.from_html(
		`

<nav class="fixed bottom-0 right-0 m-5 md:m-10 flex items-center bg-ink text-accent font-display font-semibold">
  <a class="px-4 py-3 hover:bg-accent hover:text-ink transition-colors" aria-label="Previous concept">←</a>
  <span class="px-2 py-3 tabular-nums"> </span>
  <a class="px-4 py-3 hover:bg-accent hover:text-ink transition-colors" aria-label="Next concept">→</a>
</nav>`,
		1
	),
	Switcher[$.FILENAME],
	[[9, 0, [[10, 2], [11, 2], [12, 2]]]]
);

function Switcher($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, Switcher);

	const total = $$props.titles.length;
	const prev = ($$props.current - 1 + total) % total + 1;
	const next = ($$props.current + 1) % total + 1;
	var $$exports = { ...$.legacy_api() };

	$.next();

	var fragment = root();
	var nav = $.sibling($.first_child(fragment));
	var a = $.sibling($.child(nav));
	var span = $.sibling(a, 2);
	var text = $.only_child(span);
	var a_1 = $.sibling(span, 2);

	$.next();
	$.reset(nav);

	$.template_effect(() => {
		$.set_attribute(a, 'href', `/${prev}`);
		$.set_text(text, `${$$props.current + 1}/${total ?? ''} · ${$$props.titles[$$props.current] ?? ''}`);
		$.set_attribute(a_1, 'href', `/${next}`);
	});

	$.append($$anchor, fragment);

	return $.pop($$exports);
}

if (import.meta.hot) {
	Switcher = $.hmr(Switcher);

	import.meta.hot.accept((module) => {
		Switcher[$.HMR].update(module.default);
	});
}

export default Switcher;